var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExternal = function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 17.333v8a1.324 1.324 0 0 1-.391.942 1.331 1.331 0 0 1-.942.391H6.667a1.324 1.324 0 0 1-.942-.391 1.331 1.331 0 0 1-.391-.942V10.666a1.324 1.324 0 0 1 .391-.942 1.331 1.331 0 0 1 .942-.391h8a1.333 1.333 0 0 0 0-2.666h-8a3.997 3.997 0 0 0-4 4v14.667a3.997 3.997 0 0 0 4 4.001h14.667a3.997 3.997 0 0 0 4.001-4v-8a1.333 1.333 0 0 0-2.666 0zm-8.391 2.276L26.667 7.218v4.781a1.333 1.333 0 0 0 2.666 0V3.988a1.338 1.338 0 0 0-1.321-1.323H20a1.333 1.333 0 0 0 0 2.666h4.781L12.39 17.722a1.332 1.332 0 1 0 1.885 1.885z"
  })));
};

export default SvgExternal;